import { React, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import useToken from '../../util/useToken';

import { getOAXray } from '../../util/api';
import { addOAXray } from '../../util/api';
import { updateOAXray } from '../../util/api';
import { deleteOAXray } from '../../util/api';

import { getFilterOptions } from '../../util/api';
import TextInput from '../TextInput';

import './OAXray.css'

export default function OAXray ( { OAID } ) {
    const [ loading, setLoading ] = useState(true);
    const loadingGIF = require('../../content/loading.gif');
    const { token, setToken, removeToken, validToken} = useToken();
    const [ firstLoad, setFirstLoad ] = useState(true);
    const [ imageAnalysis, setImageAnalysis ] = useState({"results":[]});
    const [ editMode, setEditMode ] = useState(false);
    const [ viewMode, setViewMode ] = useState(false);
    const [ selectedId, setSelectedId ] = useState(null);
    const [ refresh, setRefresh ] = useState(false);
    const [ viewingSanger, setViewingSanger ] = useState(false);

    //Pagination variables
    const [ page, setPage ] = useState(1)
    const [ editedPage, setEditedPage] = useState(1);
    const [ pageSize, setPageSize ] = useState(5)
    const [ resultCount, setResultCount ] = useState(0);

    const [options, setOptions] = useState({"windDirections":[], "conditions":[], "species":[], "siteMarshes":[], "storageBuffers":[], "sites":[], "imageTypes":[]});
    
    const [ currentObject, setCurrentObject ] = useState({});

    const handleCheckboxChange = (event, id) => {
        if(id === selectedId){
            setSelectedId(null)
        }else{
            setSelectedId(id);
        }
    };

    useEffect(() => {
        getOAXray(token, OAID, page, pageSize).then(response => {
            response.json().then(json => {
                if(response.status !== 200){
                    alert(json["message"])
                }else{
                    setImageAnalysis(json)
                    setResultCount(json["resultCount"])
                }
            })
            setRefresh(false)
            setLoading(false)
        })
    }, [refresh, page])

    const handleInputChange = (event, name) => {
        setCurrentObject({
            ...currentObject,
            [name]: event.target.value,
        });
        const updatedInformation = {
            ...imageAnalysis,
            results: imageAnalysis.results.map(item => {
                if (item.id === editMode) {
                    return {
                        ...item,
                        [name]: event.target.value
                    };
                }
                return item;
            })
        };
    
        setImageAnalysis(updatedInformation);

    };

    useEffect(() => {
        const fetchOptions = async () => {
            let options = await getFilterOptions(token);
            setOptions(options)
        }
        fetchOptions();
    }, []);

    const deleteImageAnalysisRow = () => {
        deleteOAXray(token, selectedId).then(response => {
            response.json().then(json => {
                if(response.status !== 200){
                    alert(json["message"])
                }else{
                    setRefresh(true)
                    setSelectedId(null)
                }
            })
        })
    }
    
    const addImageAnalysisRow = () => {
        setCurrentObject({"id":-1, "oceanacidificationID":OAID})
        setEditMode(true)
        setViewMode(true)
        setSelectedId(-1)
    }

    const handleOnClickEditOrSave = () => {
        if(editMode == true){
            if(currentObject["id"] !== -1){
                updateOAXray(token, currentObject).then(response => {
                    response.json().then(json => {
                        if(response.status !== 200){
                            alert(json["message"])
                        }else{
                            setRefresh(true)
                            setEditMode(false)
                        }
                    })
                })
            }else{
                addOAXray(token, currentObject).then(response => {
                    response.json().then(json => {
                        if(response.status !== 200){
                            alert(json["message"])
                        }else{
                            setRefresh(true)
                            setEditMode(false)
                        }
                    })
                })
            }
        }else{
            setEditMode(true)
        }
    }


    const handleFowardClick = () => {
        if(page < (resultCount / pageSize)){
            setPage(page + 1)
        }
    }

    const handleBackClick = () => {
        if(page > 1){
            setPage(page - 1)
        }
    }
    
    return(
        <div>
            {(loading || refresh) && 
                <div className="loading-position">
                    <img src={loadingGIF}></img>
                </div>
            }
            {!viewMode &&
            <div className="image-table-container">
                <div className="image-table-buttons">
                    <div>
                        <button disabled={!selectedId} onClick={() => {setViewMode(true); setCurrentObject(imageAnalysis?.results.find(item => item.id === selectedId))}}>View</button>
                        <button onClick={() => {addImageAnalysisRow()}}>Add</button>
                        <button disabled={!selectedId} onClick={() => {deleteImageAnalysisRow()}}>Delete</button>
                    </div>
                    <div>
                        <button onClick={() => {handleBackClick()}}>{"<"}</button>
                        <input
                            className="page-input"
                            type="number"
                            value={editedPage}
                            onChange={(event) => {setEditedPage(event.target.valueAsNumber || editedPage)}}
                            onBlur={(event) => {
                                const enteredPage = event.target.valueAsNumber || editedPage;
                                const maxPage = Math.ceil(resultCount / pageSize);
                                setPage(Math.max(1, Math.min(enteredPage, maxPage)));
                                setEditedPage(Math.max(1, Math.min(enteredPage, maxPage)));
                              }}
                        />
                        <button onClick={() => {handleFowardClick()}}>{">"}</button>
                    </div>
                </div>
                <table className="image-table">
                    <thead>
                        <tr>
                            <th></th>
                            <th>Link</th>
                        </tr>
                    </thead>
                    <tbody>
                        {imageAnalysis?.results.length > 0 && imageAnalysis?.results?.map((result) => (
                            <tr key={result.id}>
                                <td>
                                    <input
                                        type="checkbox"
                                        checked={selectedId === result.id}
                                        onChange={event => handleCheckboxChange(event, result.id)}
                                    />
                                </td>
                                <td>{result.link}</td>
                            </tr>
                        ))}
                        {imageAnalysis?.results.length == 0 &&
                            <tr>
                                <td colSpan="6" style={{ textAlign: 'center' }}>
                                    <p>No Results</p>
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
                {resultCount !== 0 ? <p>{page}/{Math.ceil(resultCount/pageSize)}</p> : <p></p>}
            </div>   
            }
            {viewMode && selectedId &&
                <div>
                    <button onClick={() => {setViewMode(false); setRefresh(true); setEditMode(false)}}>Back</button>
                    <button onClick={() => {handleOnClickEditOrSave()}}>{editMode ? "Save" : "Edit"}</button>
                    <div className="information-container">
                        <div>
                            <TextInput
                                label="Link"
                                value={currentObject["link"]} 
                                onChange={(event) => {handleInputChange(event, "link")}}
                                editable={editMode}
                            />
                        </div>                              
                    </div>
                </div>
            }
        </div>
    );

  }